import React from "react";
import Modal from '../Modal'
import LoaderButton from "../../components/LoaderButton";
import { translate } from "../../utils/useful";
import ButtonAnimated from "../buttons/ButtonAnimated";


class EndQuiz extends React.Component {
    state = {
    }

    componentDidMount() {
    }

    endInqury = () => {
        this.props.endInquiryModal()

    }

    render() {
        let options = this.state.options
        return (

            <Modal ref={el => this.modal = el} maxWidth={400}>
                <div className="w-100 br-10 p-3" style={{ backgroundColor: "white" }} >
                    {/* <div className="flexcc">
                        <img width={200} src="/assets/icons/svgs/endexam.svg" />
                    </div> */}
                    <div className="w-100 flexcc">
                        <p className="py-2 font-size-16 weight-500" style={{ color: '#222' }}>{translate('Are you sure you want to leave the quiz?')}</p>
                    </div>
                    <div className="flexcc pt-3 pb-1" style={{}}>
                        <div className="mrd-1">
                            <ButtonAnimated
                                // icon={'/assets/icons/arrow-right-white.svg'}
                                bg={'rgba(120, 120, 120, 0.1)'}
                                title={translate('Cancel')}
                                textColor={'rgba(120, 120, 120)'}
                                onClick={() => this.modal.hideModal()}
                            />
                        </div>
                        <div className="mld-1">
                            <ButtonAnimated
                                icon={'/assets/icons/arrow-right-white.svg'}
                                bg={this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, #6E9318, #96C723)'}
                                title={translate('End')}
                                textColor={this.props.colors ? this.props.colors.textColor : '#fff'}
                                onClick={() => this.endInqury()}
                            />
                        </div>
                        {/* <button className="modalCancelButton mrd-1" onClick={() => this.modal.hideModal()}>
                            {translate('Cancel')}
                        </button>
                        <button className='modalEndQuizButton mld-1' onClick={() => this.endInqury()}>
                            {translate('End')}
                        </button> */}
                    </div>
                </div>
            </Modal>
        );

    }
}


export default EndQuiz;
